{"NG_APP_API_URL":"https://staging.multiqos.com/wms-api/v1/"}